<template>
  <div class="elencotipotamponamentoedit">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Modifica una tipologia di tamponamento</h5>
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row>
        <b-col cols="12">
          <b-form-input class="slide-up" id="nome" v-model="formData.tamponamento.nome" type="text" :state="state.nome" placeholder="Nome della tipologia di uso" /><label for="nome">Nome *</label>
          <br>
          <br>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-textarea class="slide-up" id="note" v-model="formData.tamponamento.note" :state="state.note" rows="3" max-rows="6" /><label for="note">Note</label>
          <br>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col cols="12" md="9" offset-md="1">
          <p>* Campi obbligatori</p>
        </b-col>
        <b-col>        
          <b-button variant="success" size="lg" v-on:click="updateTipotamponamento()"><font-awesome-icon icon="marker" /> Aggiorna</b-button>
        </b-col>
      </b-row>
      <br>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'elencotipotamponamentoedit',
  data() {
    return {
      state: {
        nome: null,
        note: null
      },
      formData:{
        tamponamento: {
          nome: '',
          note: ''
        }
      }
    }
  },
  created: function(){
    this.loadTipotamponamento()
  },
  methods: {
    updateTipotamponamento(){
      Vue.http.post('elenco/tipotamponamento/update/'+this.$route.params.id, this.formData, {credentials : true}).then(response => {
        if(response.body.success){
          Vue.notify({
            group: 'global',
            title: 'Operazione riuscita!',
            text: 'Tipologia di utilizzo aggiornata con successo!',
            type: 'success'
          })
          this.$router.push('/elenco/tipotamponamento')
        }else{
          for(var i=0; i<Object.keys(this.state).length; i++){
            this.state[Object.keys(this.state)[i]] = null
          }

          for(var i=0; i<response.body.inputError.length; i++){
            this.state[response.body.inputError[i]] = false
          }

          Vue.notify({
              group: 'global',
              title: 'Problemi durante la modifica',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    },
    loadTipotamponamento(){
      Vue.http.post('elenco/tipotamponamento/load/'+this.$route.params.id, {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.formData = response.body.data
        }else{
            Vue.notify({
                group: 'global',
                title: 'Errore',
                text: response.body.msg,
                type: 'error'
            })
        }
      }, response => {})
    }
  },
  computed: {
    ...mapGetters(['stato'])
  }
}
</script>

<style scoped>
#nome{
  text-indent: 85px;
}

#note{
  text-indent: 60px;
  line-height: 1.8;
}
</style>